export default "__VITE_ASSET__CubDDw5s__"